/**
 * useDeleteVideo Hook
 * Custom hook for deleting a profile video (soft delete)
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import apiClient from "@/lib/api-client"

async function deleteVideo(userId: string, videoId: string) {
  await apiClient.delete(`api/profiles/${userId}/videos/${videoId}`)
}

export function useDeleteVideo() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ userId, videoId }: { userId: string; videoId: string }) =>
      deleteVideo(userId, videoId),
    onSuccess: async (_data, variables) => {
      // Invalidate video query to trigger refetch
      queryClient.invalidateQueries({ queryKey: ["video", variables.userId] })
    },
  })
}
